module.exports = __webpack_public_path__ + "img/Logo_Vitromex.b500a5ba.svg";